const routes = [
    {
        path: "/student/clubs",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'studentclub_index'
        }
    },
    {
        path: "/student/club/president/application",
        component: () => import("../pages/presidentApplication/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubpresidentapplication_index'
        }
    },
    {
        path: '/student/club/president/application/users/:id',
        component: () => import('../pages/presidentApplicationUsers/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubvoteoption_index'
        }
    },
    {
        path: "/my-student-clubs",
        component: () => import("../pages/student/Index"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    },
    {
        path: "/student/club/events",
        component: () => import("../pages/events/Index"),
        meta: {
            isAuthenticated: true,
            //permission: 'studentclub_index'
        }
    },
    {
        path: "/student/club/events/:id",
        component: () => import("../pages/events/Detail"),
        meta: {
            isAuthenticated: true,
            //permission: 'studentclub_index'
        }
    },
];

export default routes;
